import { render, staticRenderFns } from "./FirstHomeStep.vue?vue&type=template&id=0d20a8e6&"
import script from "./FirstHomeStep.vue?vue&type=script&lang=js&"
export * from "./FirstHomeStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports